export const {
  NODE_ENV,
  GTM_TAG_ID,
  UMAMI_TRACKING_URL,
  UMAMI_TRACKING_ID,
  CLASSIC_WEBSITE_URL,
  MODERN_WEBSITE_URL,
  TRANSAK_API_KEY,
  TRANSAK_ENV,
  WEB_ENGAGE_LICENSE_CODE,
  PRIVY_APP_ID,
  PRIVY_APP_SECRET,
  PRIVY_WEBHOOK_SIGNING_KEY,
  AFFNOOK_API_KEY,
  OVERTIME_API_KEY,
  OVERTIME_AFFILIATE_ADDRESS,
  AFFILIATE_ADDRESS,
  SHORT_IO_API_KEY,
  SHORT_IO_DOMAIN,
  POLYGON_RPC_URL,
  PIMLICO_API_KEY,
} = {
  NODE_ENV: process.env.NEXT_PUBLIC_NODE_ENV,
  GTM_TAG_ID: process.env.GTM_TAG_ID,
  UMAMI_TRACKING_URL: process.env.UMAMI_TRACKING_URL,
  UMAMI_TRACKING_ID: process.env.UMAMI_TRACKING_ID,
  CLASSIC_WEBSITE_URL: process.env.NEXT_PUBLIC_CLASSIC_WEBSITE_URL,
  MODERN_WEBSITE_URL: process.env.NEXT_PUBLIC_MODERN_WEBSITE_URL,
  TRANSAK_API_KEY: process.env.NEXT_PUBLIC_TRANSAK_API_KEY,
  TRANSAK_ENV: process.env.NEXT_PUBLIC_TRANSAK_ENV,
  WEB_ENGAGE_LICENSE_CODE: process.env.NEXT_PUBLIC_WEB_ENGAGE_LICENSE_CODE,
  PRIVY_APP_ID: process.env.NEXT_PUBLIC_PRIVY_APP_ID,
  PRIVY_APP_SECRET: process.env.PRIVY_APP_SECRET,
  PRIVY_WEBHOOK_SIGNING_KEY: process.env.PRIVY_WEBHOOK_SIGNING_KEY,
  AFFNOOK_API_KEY: process.env.NEXT_PUBLIC_AFFNOOK_API_KEY,
  OVERTIME_API_KEY: process.env.NEXT_PUBLIC_OVERTIME_API_KEY,
  OVERTIME_AFFILIATE_ADDRESS:
    process.env.NEXT_PUBLIC_OVERTIME_AFFILIATE_ADDRESS,
  AFFILIATE_ADDRESS: process.env.NEXT_PUBLIC_AFFILIATE_ADDRESS,
  SHORT_IO_API_KEY: process.env.NEXT_PUBLIC_SHORT_IO_API_KEY,
  SHORT_IO_DOMAIN: process.env.NEXT_PUBLIC_SHORT_IO_DOMAIN,
  POLYGON_RPC_URL: process.env.NEXT_PUBLIC_POLYGON_RPC_URL || '',
  PIMLICO_API_KEY: process.env.NEXT_PUBLIC_PIMLICO_API_KEY,
}
